import React, { useEffect, useState } from "react";
import { Values } from "../Helpers/Enums";
import ErrorField from "./ErrorField";
import { CommonError_Msgs } from "../Helpers/HelperText";

const DietAdministrationTable = ({ dietData, handleRadioChange, fieldData, errorData }) => {
    const [isQ61True, setIsQ61True] = useState(true);
    useEffect(() => {
        const hasTrueValue = Object.values(dietData).some(value => value === true);
        setIsQ61True(hasTrueValue)
    }, [dietData])
    return (
        <>
            {isQ61True && (
                (dietData?.pretransplant_routes_unknown === Values.value99 || dietData?.pretransplant_routes_unknown === true) &&
                    (dietData?.transplant_admission_routes_unknown === Values.value99 || dietData?.transplant_admission_routes_unknown === true) &&
                    (dietData?.transplant_discharge_routes_unknown === Values.value99 || dietData?.transplant_discharge_routes_unknown === true) &&
                    (dietData?.three_month_routes_unknown === Values.value99 || dietData?.three_month_routes_unknown === true) &&
                    (dietData?.twelve_month_routes_unknown === Values.value99 || dietData?.twelve_month_routes_unknown === true) &&

                    (dietData?.twentyfour_month_routes_unknown === Values.value99 || dietData?.twentyfour_month_routes_unknown === true) ? (
                    <div></div>
                )
                    : (
                        <div>
                            <div>
                                <div className="question-answer">
                                    {/* mainContent */}
                                    <table
                                        cellPadding="0"
                                        cellSpacing="0"
                                        width="100%"
                                        border="1"
                                        className="borderTable negative-margin-two"
                                    >
                                        <tr>
                                            <td className="containertd" colSpan={7}>
                                                <div className="question question-weight">
                                                    <span className="question-weight"> Q61.1.</span><span className="quest-text-pad"> Please provide the estimated
                                                        percentage of calories consumed via the multiple routes of
                                                        diet administration reported above in Q61. Check that
                                                        categories sum to ~100% across all routes of diet
                                                        administration.{" "}</span>
                                                </div>

                                                <br />
                                            </td>
                                        </tr>

                                        {/* <tr>
                                                    <td colSpan="6" style={{ padding: 0 }}>
                                                        <table style={{ width: "100%" }} className="borderTable custom-column-table negative-margin-three">
                                                            <tbody> */}
                                        <tr>
                                            <td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div className="question-weight">
                                                        <label className="long-text-option question-weight">
                                                            Oral Feeding
                                                        </label>
                                                    </div>
                                                </>
                                            </td>

                                            {(dietData?.pretransplant_oral && (dietData?.pretransplant_parental || dietData?.pretransplant_eternal)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio"
                                                                checked={fieldData[Values.value1]?.pre_oral === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value1, "pre_oral")}
                                                                id="" name="preOral" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio"
                                                                checked={fieldData[Values.value1]?.pre_oral === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value2, "pre_oral")}
                                                                id="" name="preOral" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" checked={fieldData[Values.value1]?.pre_oral === Values.value3} onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value3, "pre_oral")}
                                                                id="" name="preOral" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio"
                                                                checked={fieldData[Values.value1]?.pre_oral === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value4, "pre_oral")}
                                                                id="" name="preOral" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio"
                                                                checked={fieldData[Values.value1]?.pre_oral === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value5, "pre_oral")}
                                                                id="" name="preOral" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio"
                                                                checked={fieldData[Values.value1]?.pre_oral === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value99, "pre_oral")}
                                                                id="" name="preOral" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[1]?.[0] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.transplant_admission_oral && (dietData?.transplant_admission_parental || dietData?.transplant_admission_eternal)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.trans_oral === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value1, "trans_oral")}
                                                                name="transOral" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.trans_oral === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value2, "trans_oral")}
                                                                name="transOral" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.trans_oral === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value3, "trans_oral")}
                                                                name="transOral" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.trans_oral === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value4, "trans_oral")}
                                                                name="transOral" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.trans_oral === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value5, "trans_oral")}
                                                                name="transOral" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.trans_oral === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value99, "trans_oral")}
                                                                name="transOral" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[1]?.[1] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.transplant_discharge_oral && (dietData?.transplant_discharge_parental || dietData?.transplant_discharge_eternal)) ? (
                                                <td
                                                    className="containertd"
                                                    style={{
                                                        borderBottom: "0",
                                                    }}
                                                >
                                                    <>
                                                        <div>
                                                            <label className="long-text-option">
                                                                <input type="radio" id=""
                                                                    checked={fieldData[Values.value1]?.trans_dis_oral === Values.value1}
                                                                    onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value1, "trans_dis_oral")}
                                                                    name="dischargeOral" />
                                                                <span className="radio-text-padding">
                                                                    &lt;25%
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div>
                                                            <label className="long-text-option">
                                                                <input type="radio" id=""
                                                                    checked={fieldData[Values.value1]?.trans_dis_oral === Values.value2}
                                                                    onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value2, "trans_dis_oral")}
                                                                    name="dischargeOral" />
                                                                <span className="radio-text-padding">
                                                                    25% to &lt;50%
                                                                </span>
                                                            </label>
                                                        </div>

                                                        <div>
                                                            <label className="long-text-option">
                                                                <input type="radio" id=""
                                                                    checked={fieldData[Values.value1]?.trans_dis_oral === Values.value3}
                                                                    onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value3, "trans_dis_oral")}
                                                                    name="dischargeOral" />
                                                                <span className="radio-text-padding">
                                                                    50% to &lt;75%
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div>
                                                            <label className="long-text-option">
                                                                <input type="radio" id=""
                                                                    checked={fieldData[Values.value1]?.trans_dis_oral === Values.value4}
                                                                    onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value4, "trans_dis_oral")}
                                                                    name="dischargeOral" />
                                                                <span className="radio-text-padding">
                                                                    75% to &lt;100%
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div>
                                                            <label className="long-text-option">
                                                                <input type="radio" id=""
                                                                    checked={fieldData[Values.value1]?.trans_dis_oral === Values.value5}
                                                                    onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value5, "trans_dis_oral")}
                                                                    name="dischargeOral" />
                                                                <span className="radio-text-padding">
                                                                    100%
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div>
                                                            <label className="long-text-option">
                                                                <input type="radio" id=""
                                                                    checked={fieldData[Values.value1]?.trans_dis_oral === Values.value99}
                                                                    onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value99, "trans_dis_oral")}
                                                                    name="dischargeOral" />
                                                                <span className="radio-text-padding">
                                                                    Unknown
                                                                </span>
                                                            </label>
                                                        </div>
                                                        {errorData["Q61.1."]?.[1]?.[Values.value2] && (
                                                            <ErrorField
                                                                show={true}
                                                                message={CommonError_Msgs.Msg1}
                                                            />
                                                        )}
                                                    </>
                                                </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.three_month_oral && (dietData?.three_month_parental || dietData?.three_month_eternal)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.threeoral === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value1, "threeoral")}
                                                                name="threeOral" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.threeoral === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value2, "threeoral")}
                                                                name="threeOral" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.threeoral === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value3, "threeoral")}
                                                                name="threeOral" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.threeoral === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value4, "threeoral")}
                                                                name="threeOral" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.threeoral === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value5, "threeoral")}
                                                                name="threeOral" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.threeoral === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value99, "threeoral")}
                                                                name="threeOral" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[1]?.[Values.value3] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.twelve_month_oral && (dietData?.twelve_month_parental || dietData?.twelve_month_eternal)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.twelve_oral === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value1, "twelve_oral")}
                                                                name="twelveOral" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.twelve_oral === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value2, "twelve_oral")}
                                                                name="twelveOral" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.twelve_oral === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value3, "twelve_oral")}
                                                                name="twelveOral" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.twelve_oral === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value4, "twelve_oral")}
                                                                name="twelveOral" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.twelve_oral === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value5, "twelve_oral")}
                                                                name="twelveOral" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.twelve_oral === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value99, "twelve_oral")}
                                                                name="twelveOral" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[1]?.[Values.value4] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.twentyfour_month_oral && (dietData?.twentyfour_month_parental || dietData?.twentyfour_month_eternal)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.twentfour_oral === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value1, "twentfour_oral")}
                                                                name="twentfourOral" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.twentfour_oral === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value2, "twentfour_oral")}

                                                                name="twentfourOral" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.twentfour_oral === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value3, "twentfour_oral")}

                                                                name="twentfourOral" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.twentfour_oral === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value4, "twentfour_oral")}

                                                                name="twentfourOral" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.twentfour_oral === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value5, "twentfour_oral")}

                                                                name="twentfourOral" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value1]?.twentfour_oral === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value1, Values.value99, "twentfour_oral")}

                                                                name="twentfourOral" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[1]?.[Values.value4] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                        </tr>
                                        <tr>
                                            <td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div className="question-weight">
                                                        <label className="long-text-option">
                                                            Enteral/IV-based feeding
                                                        </label>
                                                    </div>
                                                </>
                                            </td>

                                            {(dietData?.pretransplant_eternal && (dietData?.pretransplant_oral || dietData?.pretransplant_parental)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio"
                                                                checked={fieldData[Values.value2]?.pre_enteral === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value1, "pre_enteral")}
                                                                id="" name="preEnt" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.pre_enteral === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value2, "pre_enteral")}
                                                                name="preEnt" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.pre_enteral === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value3, "pre_enteral")}
                                                                name="preEnt" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.pre_enteral === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value4, "pre_enteral")}
                                                                name="preEnt" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.pre_enteral === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value5, "pre_enteral")}
                                                                name="preEnt" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.pre_enteral === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value99, "pre_enteral")}
                                                                name="preEnt" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[Values.value2]?.[0] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.transplant_admission_eternal && (dietData?.transplant_admission_oral || dietData?.transplant_admission_parental)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.trans_enteral === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value1, "trans_enteral")}
                                                                name="transEnt" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.trans_enteral === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value2, "trans_enteral")}
                                                                name="transEnt" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.trans_enteral === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value3, "trans_enteral")}
                                                                name="transEnt" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.trans_enteral === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value4, "trans_enteral")}
                                                                name="transEnt" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.trans_enteral === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value5, "trans_enteral")}
                                                                name="transEnt" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.trans_enteral === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value99, "trans_enteral")}
                                                                name="transEnt" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[Values.value2]?.[1] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.transplant_discharge_eternal && (dietData?.transplant_discharge_oral || dietData?.transplant_discharge_parental)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.trans_dis_enteral === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value1, "trans_dis_enteral")}
                                                                name="dischargeEnt" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.trans_dis_enteral === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value2, "trans_dis_enteral")}
                                                                name="dischargeEnt" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.trans_dis_enteral === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value3, "trans_dis_enteral")}
                                                                name="dischargeEnt" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.trans_dis_enteral === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value4, "trans_dis_enteral")}
                                                                name="dischargeEnt" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.trans_dis_enteral === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value5, "trans_dis_enteral")}
                                                                name="dischargeEnt" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.trans_dis_enteral === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value99, "trans_dis_enteral")}
                                                                name="dischargeEnt" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[Values.value2]?.[Values.value2] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                    {/* <div>
        <label>
          <input
            type="radio"
            id=""
            name="" 
          />
          <span className="radio-text-padding">
            Date Unknown
          </span>
        </label>
      </div> */}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.three_month_eternal && (dietData?.three_month_oral || dietData?.three_month_parental)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.three_enteral === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value1, "three_enteral")}
                                                                name="threeEnt" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.three_enteral === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value2, "three_enteral")}
                                                                name="threeEnt" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.three_enteral === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value3, "three_enteral")}
                                                                name="threeEnt" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.three_enteral === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value4, "three_enteral")}
                                                                name="threeEnt" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.three_enteral === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value5, "three_enteral")}
                                                                name="threeEnt" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.three_enteral === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value99, "three_enteral")}
                                                                name="threeEnt" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[Values.value2]?.[Values.value3] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                    {/* <div>
        <label>
          <input
            type="radio"
            id=""
            name="" 
          />
          <span className="radio-text-padding">
            Date Unknown
          </span>
        </label>
      </div> */}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.twelve_month_eternal && (dietData?.twelve_month_oral || dietData?.twelve_month_parental)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.twelve_enteral === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value1, "twelve_enteral")}
                                                                name="twelveEnt" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.twelve_enteral === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value2, "twelve_enteral")}
                                                                name="twelveEnt" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.twelve_enteral === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value3, "twelve_enteral")}
                                                                name="twelveEnt" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.twelve_enteral === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value4, "twelve_enteral")}
                                                                name="twelveEnt" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.twelve_enteral === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value5, "twelve_enteral")}
                                                                name="twelveEnt" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.twelve_enteral === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value99, "twelve_enteral")}
                                                                name="twelveEnt" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[Values.value2]?.[Values.value4] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                    {/* <div>
        <label>
          <input
            type="radio"
            id=""
            name="" 
          />
          <span className="radio-text-padding">
            Date Unknown
          </span>
        </label>
      </div> */}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.twentyfour_month_eternal && (dietData?.twentyfour_month_oral || dietData?.twentyfour_month_parental)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.twentfour_enteral === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value1, "twentfour_enteral")}
                                                                name="twentyfourEnt" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.twentfour_enteral === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value2, "twentfour_enteral")}
                                                                name="twentyfourEnt" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.twentfour_enteral === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value3, "twentfour_enteral")}
                                                                name="twentyfourEnt" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.twentfour_enteral === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value4, "twentfour_enteral")}
                                                                name="twentyfourEnt" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.twentfour_enteral === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value5, "twentfour_enteral")}
                                                                name="twentyfourEnt" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value2]?.twentfour_enteral === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value2, Values.value99, "twentfour_enteral")}
                                                                name="twentyfourEnt" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[Values.value2]?.[Values.value4] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                    {/* <div>
        <label>
          <input
            type="radio"
            id=""
            name="" 
          />
          <span className="radio-text-padding">
            Date Unknown
          </span>
        </label>
      </div> */}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                        </tr>
                                        <tr>
                                            <td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div className="question-weight">
                                                        <label className="long-text-option">
                                                            Parenteral/tube-based feeding
                                                        </label>
                                                    </div>
                                                </>
                                            </td>

                                            {(dietData?.pretransplant_parental && (dietData?.pretransplant_oral || dietData?.pretransplant_eternal)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.pre_parental === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value1, "pre_parental")}
                                                                name="prePar" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.pre_parental === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value2, "pre_parental")}
                                                                name="prePar" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.pre_parental === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value3, "pre_parental")}
                                                                name="prePar" />
                                                            <span className="radio-text-padding">
                                                                {/* checked={fieldData[Values.value3]?.pre_parental === Values.value5} */}
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.pre_parental === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value4, "pre_parental")}
                                                                name="prePar" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.pre_parental === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value5, "pre_parental")}
                                                                name="prePar" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.pre_parental === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value99, "pre_parental")}
                                                                name="prePar" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[Values.value3]?.[0] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                    {/* <div>
        <label>
          <input
            type="radio"
            id=""
            name="" 
          />
          <span className="radio-text-padding">
            Date Unknown
          </span>
        </label>
      </div> */}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.transplant_admission_parental && (dietData?.transplant_admission_oral || dietData?.transplant_admission_eternal)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.trans_parental === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value1, "trans_parental")}
                                                                name="transPar" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.trans_parental === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value2, "trans_parental")}
                                                                name="transPar" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.trans_parental === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value3, "trans_parental")}
                                                                name="transPar" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.trans_parental === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value4, "trans_parental")}
                                                                name="transPar" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.trans_parental === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value5, "trans_parental")}
                                                                name="transPar" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.trans_parental === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value99, "trans_parental")}
                                                                name="transPar" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[Values.value3]?.[1] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                    {/* <div>
        <label>
          <input
            type="radio"
            id=""
            name="" 
          />
          <span className="radio-text-padding">
            Date Unknown
          </span>
        </label>
      </div> */}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.transplant_discharge_parental && (dietData?.transplant_discharge_oral || dietData?.transplant_discharge_eternal)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.trans_dis_parental === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value1, "trans_dis_parental")}
                                                                name="dischargePar" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.trans_dis_parental === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value2, "trans_dis_parental")}
                                                                name="dischargePar" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.trans_dis_parental === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value3, "trans_dis_parental")}
                                                                name="dischargePar" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.trans_dis_parental === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value4, "trans_dis_parental")}
                                                                name="dischargePar" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.trans_dis_parental === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value5, "trans_dis_parental")}
                                                                name="dischargePar" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.trans_dis_parental === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value99, "trans_dis_parental")}
                                                                name="dischargePar" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[Values.value3]?.[Values.value2] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                    {/* <div>
        <label>
          <input
            type="radio"
            id=""
            name="" 
          />
          <span className="radio-text-padding">
            Date Unknown
          </span>
        </label>
      </div> */}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.three_month_parental && (dietData?.three_month_oral || dietData?.three_month_eternal)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.three_parental === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value1, "three_parental")}
                                                                name="threePar" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.three_parental === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value2, "three_parental")}
                                                                name="threePar" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.three_parental === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value3, "three_parental")}
                                                                name="threePar" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.three_parental === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value4, "three_parental")}
                                                                name="threePar" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.three_parental === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value5, "three_parental")}
                                                                name="threePar" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.three_parental === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value99, "three_parental")}
                                                                name="threePar" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[Values.value3]?.[Values.value3] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                    {/* <div>
        <label>
          <input
            type="radio"
            id=""
            name="" 
          />
          <span className="radio-text-padding">
            Date Unknown
          </span>
        </label>
      </div> */}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.twelve_month_parental && (dietData?.twelve_month_oral || dietData?.twelve_month_eternal)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.twelve_parental === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value1, "twelve_parental")}
                                                                name="twelvePar" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.twelve_parental === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value2, "twelve_parental")}
                                                                name="twelvePar" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.twelve_parental === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value3, "twelve_parental")}
                                                                name="twelvePar" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.twelve_parental === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value4, "twelve_parental")}
                                                                name="twelvePar" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.twelve_parental === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value5, "twelve_parental")}
                                                                name="twelvePar" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.twelve_parental === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value99, "twelve_parental")}
                                                                name="twelvePar" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[Values.value3]?.[Values.value4] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                    {/* <div>
        <label>
          <input
            type="radio"
            id=""
            name="" 
          />
          <span className="radio-text-padding">
            Date Unknown
          </span>
        </label>
      </div> */}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                            {(dietData?.twentyfour_month_parental && (dietData?.twentyfour_month_oral || dietData?.twentyfour_month_eternal)) ? (<td
                                                className="containertd"
                                                style={{
                                                    borderBottom: "0",
                                                }}
                                            >
                                                <>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.twentfour_parental === Values.value1}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value1, "twentfour_parental")}
                                                                name="twentyfourPar" />
                                                            <span className="radio-text-padding">
                                                                &lt;25%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.twentfour_parental === Values.value2}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value2, "twentfour_parental")}
                                                                name="twentyfourPar" />
                                                            <span className="radio-text-padding">
                                                                25% to &lt;50%
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.twentfour_parental === Values.value3}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value3, "twentfour_parental")}
                                                                name="twentyfourPar" />
                                                            <span className="radio-text-padding">
                                                                50% to &lt;75%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.twentfour_parental === Values.value4}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value4, "twentfour_parental")}
                                                                name="twentyfourPar" />
                                                            <span className="radio-text-padding">
                                                                75% to &lt;100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.twentfour_parental === Values.value5}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value5, "twentfour_parental")}
                                                                name="twentyfourPar" />
                                                            <span className="radio-text-padding">
                                                                100%
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label className="long-text-option">
                                                            <input type="radio" id=""
                                                                checked={fieldData[Values.value3]?.twentfour_parental === Values.value99}
                                                                onChange={(e) => handleRadioChange(e, "Q61.1.", Values.value3, Values.value99, "twentfour_parental")}
                                                                name="twentyfourPar" />
                                                            <span className="radio-text-padding">
                                                                Unknown
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {errorData["Q61.1."]?.[Values.value3]?.[Values.value4] && (
                                                        <ErrorField
                                                            show={true}
                                                            message={CommonError_Msgs.Msg1}
                                                        />
                                                    )}
                                                    {/* <div>
        <label>
          <input
            type="radio"
            id=""
            name="" 
          />
          <span className="radio-text-padding">
            Date Unknown
          </span>
        </label>
      </div> */}
                                                </>
                                            </td>) : (
                                                <td className="containertd question-weight cust-align">Not Applicable</td>
                                            )}
                                        </tr>
                                        {/* </tbody>
                                                        </table>
                                                    </td>
                                                </tr> */}
                                    </table>
                                </div>
                            </div>
                        </div>)

            )}
        </>
    );
};

export default DietAdministrationTable;
